export class LoginDTO {
    User: string;
    OtpCode: string | null;
    RegisterDevice: boolean | null;
    RegistrationToken: string | null;
}

export class LoginPasswordDTO {
    User: string;
    Password: string | null;
    RegistrationToken: string | null;
    RolesListInt: number[] | null;
    PassMustBeDifferent: boolean;
}

export class RefreshTokenDTO {
    IdUser: number;
    Token: string;
    RefreshToken: string;
    PassLifeTime: boolean | null;
    PassRetry: boolean | null;
    RegistrationNeeded: boolean | null;
    RegistrationToken: string | null;
    TotpNeeded: boolean | null;
    TotpValid: boolean | null;
}

export class OtpDTO {
    User: string;
    OtpCode: string;
    RegisterDevice: boolean | null;
    RegistrationToken: string | null;
}

export class MfaCodeModel {
    Code: string;
    EmailUser: string | null;
    IdUser: string | null;

    constructor({ code, email = null, idUser = null }) {
        this.Code = code;
        this.EmailUser = email;
        this.IdUser = idUser;
    }
}